import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';
import { Channel } from '@/shared/model/scrap-agent.model';
import VueCustomScrollbar from 'vue-custom-scrollbar/src/vue-scrollbar.vue';
import account from '@/router/account';

@Component({
  methods: {
    account() {
      return account;
    },
  },
  components: { VueCustomScrollbar },
})
export default class Step2Component extends Vue {
  @PropSync('listChannel', { type: Array })
  formDataStep2!: Channel[];
  accountIds: Record<string, string> = {};

  scrollSettings = { wheelPropagation: true };
  @Prop() scrollRef!: HTMLElement | null;

  @Watch('formDataStep2', { deep: true, immediate: true })
  onFormDataStep2Change(): void {
    if (this.formDataStep2) {
      this.$emit('handle::change-step2', this.formDataStep2);
    }
  }

  changeStatus(item: Channel, accountIndex: number, index?: number) {
    // Start by creating a deep copy of the array
    const updatedData = JSON.parse(JSON.stringify(this.formDataStep2));

    // Find the exact channel by index or properties
    const channelIndex = updatedData.findIndex(
      channel =>
        channel === item ||
        (channel.channelId && item.channelId && channel.channelId === item.channelId) ||
        (channel.channelName && item.channelName && channel.channelName === item.channelName)
    );

    if (channelIndex === -1) {
      console.error('Channel not found', item);
      return;
    }

    // Ensure accounts array exists
    if (!updatedData[index].accounts) {
      updatedData[index].accounts = [{ isScrap: false }];
    } else if (updatedData[index].accounts.length === 0) {
      updatedData[index].accounts.push({ isScrap: false });
    }

    // Toggle the isScrap property
    if (updatedData[index].accounts[accountIndex]) {
      updatedData[index].accounts[accountIndex].isScrap = !updatedData[index].accounts[accountIndex].isScrap;
    }

    // Update the data
    this.formDataStep2 = updatedData;
  }
  openModalRegister() {
    this.$emit('openModalRegister');
  }

  getUniqueId(account: any, channelId: string, index: number, accIndex: number): string {
    // Create a composite key with index to ensure uniqueness
    const key = `${channelId || 'no_channel'}_${account?.accountId || account?.accountName || 'no_account'}_${index}_${accIndex || 0}`;

    // If we don't have an ID for this account yet, generate one
    if (!this.accountIds[key]) {
      this.accountIds[key] = 'checkbox_' + Math.random().toString(36).substring(2, 15);
    }

    // Return the cached ID
    return this.accountIds[key];
  }

  truncateUrl(url, maxLength = 40): string {
    if (!url || url.length <= maxLength) return url || '';

    // Simple truncation that just cuts off the end of the URL
    return url.substring(0, maxLength - 3) + '...';
  }

  // In step2.component.ts, add a new truncateText method
  truncateText(text, maxLength = 40): string {
    if (!text || text.length <= maxLength) return text || '';
    return text.substring(0, maxLength - 3) + '...';
  }

  getDataSource(dataSource: any): string {
    // Handle empty data and special cases
    if (!dataSource) return '-';
    if (dataSource === 'Everything') return 'Everything';

    // Helper function to process value (handles arrays and URLs)
    const processValue = (val: any): string => {
      if (!val) return '';

      if (Array.isArray(val)) {
        return val
          .map(v => {
            if (typeof v === 'string' && v.startsWith('http')) {
              return this.truncateUrl(v);
            }
            return v;
          })
          .join(', <br>');
      }

      if (typeof val === 'string' && val.startsWith('http')) {
        return this.truncateUrl(val);
      }

      return val.toString();
    };

    // Handle objects (including the "Everything" check)
    if (typeof dataSource === 'object' && dataSource !== null) {
      // Check for "Everything" in properties
      if (dataSource.value === 'Everything' || dataSource.descriptionEn === 'Everything') {
        return 'Everything';
      }

      // Check for empty objects
      if (Object.keys(dataSource).length === 0) return '-';

      // NEW CASE: If no agentId but has dataSourceTypes, process dataSourceTypes
      if (!dataSource.agentId && dataSource.dataSourceTypes && Array.isArray(dataSource.dataSourceTypes)) {
        // return dataSource.dataSourceTypes.join('<br>');
        const types = dataSource.dataSourceTypes.join('<br>');
        const valueProcessed = processValue(dataSource.value);
        return valueProcessed ? `${types}: ${valueProcessed}` : types;
      }

      // Handle arrays
      if (Array.isArray(dataSource)) {
        if (dataSource.length === 0) return '-';

        // Check for "Everything" in array items
        for (const item of dataSource) {
          if (item === 'Everything' || (item && item.value === 'Everything') || (item && item.descriptionEn === 'Everything')) {
            return 'Everything';
          }
        }

        // Process array items
        return dataSource
          .map(ds => {
            const label = ds.descriptionEn || (Array.isArray(ds.dataSourceTypes) ? ds.dataSourceTypes.join('<br>') : '');
            const value = ds.value ? processValue(ds.value) : '';
            return label + (value ? ': ' + value : '');
          })
          .join(', <br>');
      }

      // Handle regular objects
      const description = dataSource.descriptionEn || '';

      // Check for dataSourceTypes when no agentId exists
      if (!dataSource.agentId && dataSource.dataSourceTypes && Array.isArray(dataSource.dataSourceTypes)) {
        const label =
          dataSource.descriptionEn || (Array.isArray(dataSource.dataSourceTypes) ? dataSource.dataSourceTypes.join('<br>') : '');
        const value = dataSource.value ? processValue(dataSource.value) : '';
        return label + (value ? ': ' + value : '');
      }

      const value = dataSource.value ? processValue(dataSource.value) : '';
      return description + (value ? ': ' + value : '-');
    }

    // Handle primitive values
    return dataSource.toString() || '-';
  }
}
